<span class="d-inline-flex align-items-center gap-1" aria-hidden="true">
  <span class="icon position-relative d-inline-flex align-items-center justify-content-center"
        [class.running]="showRing() || showSpinner()" [class.offline]="offline()">

    @if (showRing()) {
      <svg class="ring position-absolute" viewBox="0 0 40 40">
        <circle class="track" cx="20" cy="20" r="17" pathLength="100" />
        <circle class="arc" cx="20" cy="20" r="17" pathLength="100" [attr.stroke-dasharray]="ringDash()" transform="rotate(-90 20 20)" />
      </svg>
    } @else if (showSpinner()) {
      <svg class="ring spin position-absolute" viewBox="0 0 40 40">
        <circle class="track" cx="20" cy="20" r="17" pathLength="100" />
        <circle class="arc" cx="20" cy="20" r="17" pathLength="100" stroke-dasharray="25 100" />
      </svg>
    }

    <i class="fa fa-wave-square"></i>

    @if (offline()) {
      <svg class="ring position-absolute" viewBox="0 0 40 40">
        <line class="slash" x1="9" y1="9" x2="31" y2="31" />
      </svg>
    } @else if (attentionCount() > 0) {
      <span class="count position-absolute d-flex align-items-center justify-content-center fw-bold rounded-pill px-1"
            [class.error]="hasError()">{{badgeText()}}</span>
    }
  </span>

  @if (!offline() && readingCount() > 0) {
    <span class="reading">{{readingCount()}}</span>
  }
</span>
